import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { initFirebase } from "@/firebase/app";
import * as firebase from "firebase/app";
import "firebase/auth";
import "./registerServiceWorker";
import "@/assets/css/reset.css";
import { NS_USER } from "@/store/constants";
import { store } from "@/store/index";
import { setupLogRocket, setupSentry } from "@/util/loggers";
import LogRocket from "logrocket";

Vue.config.productionTip = false;

initFirebase();

if (process.env.NODE_ENV === "production") {
  setupSentry();
  setupLogRocket();
}

let VueStarted: any;

// Make sure the firebase auth is init before starting the vue app
firebase.auth().onAuthStateChanged(function(user: firebase.User | null) {
  if (!VueStarted) {
    VueStarted = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }

  if (user) {
    store.commit(`${NS_USER}/setUser`, user);

    LogRocket.identify(user.uid, {
      name: user.displayName || "",
      email: user.email || ""
    });
  } else {
    store.commit(`${NS_USER}/setUser`, null);
  }
});
